import React from 'react';
import { Flex, ScrollView, StackScreen } from '@banhala/ui-kit';
import { compareVersions } from 'compare-versions';
import { AnalyticsScreen } from 'shared/src/context';
import { isIOS, isNotNil } from 'shared/src/utils';
import { Image } from 'react-native';
import { LaboratorySwitch } from './components/LaboratorySwitch';
import { useLogViewLaboratory } from './hooks/useLogViewLaboratory';
import { SearchIcon, CartIcon } from 'shared/src/component';
import {
  useAppVersion,
  useHandleBackPressed,
  useLaboratorySetting,
  useReportTTFD,
} from 'shared/src/hooks';

// 홈 라이브 방송 미리보기 토글은 네이티브(iOS/Android) 대응이 포함된 버전부터 노출
const MIN_HOME_LIVE_PREVIEW_VERSION = '2.371.0';

const Laboratory = () => {
  const { showBackButton, onPressBack } = useHandleBackPressed();
  const appVersion = useAppVersion();

  const { isOn: isLikeFolderOn, setIsOn: setIsLikeFolderOn } =
    useLaboratorySetting('IS_LIKE_FOLDER');
  const { isOn: isLGifImageOn, setIsOn: setIsLGifImageOn } =
    useLaboratorySetting('IS_GIF_IMAGE');
  const { isOn: isTouchVibrationOn, setIsOn: setIsTouchVibrationOn } =
    useLaboratorySetting('IS_TOUCH_VIBRATION');
  const { isOn: isScreenShotShareOn, setIsOn: setIsScreenShotShareOn } =
    useLaboratorySetting('IS_SELECT_GOODS_SCREEN_SHOT_SHARE');
  const { isOn: isHomeLivePreviewOn, setIsOn: setIsHomeLivePreviewOn } =
    useLaboratorySetting('IS_HOME_LIVE_PREVIEW');

  const showHomeLivePreview =
    isNotNil(appVersion) &&
    compareVersions(appVersion, MIN_HOME_LIVE_PREVIEW_VERSION) >= 0;

  useLogViewLaboratory({
    IS_LIKE_FOLDER: isLikeFolderOn,
    IS_GIF_IMAGE: isLGifImageOn,
    IS_TOUCH_VIBRATION: isTouchVibrationOn,
    IS_AFTER_SCREEN_CAPTURE_SHARE: isScreenShotShareOn,
    IS_HOME_LIVE_PREVIEW: isHomeLivePreviewOn,
  });

  useReportTTFD();

  return (
    <AnalyticsScreen screen="LABORATORY">
      <StackScreen
        title="실험실"
        hideBackButton={!showBackButton}
        onPressBack={onPressBack}
        rightIcons={[<SearchIcon />, <CartIcon />]}
      >
        <ScrollView>
          <Flex padding={{ vertical: 24 }} alignItems="center">
            <Image
              source={require('./images/img_lab.png')}
              style={{ height: 104 }}
              resizeMode="contain"
            />
          </Flex>

          <LaboratorySwitch
            laboratoryKey="IS_LIKE_FOLDER"
            isOn={isLikeFolderOn ?? false}
            onChange={setIsLikeFolderOn}
          />
          <LaboratorySwitch
            laboratoryKey="IS_GIF_IMAGE"
            isOn={isLGifImageOn ?? false}
            onChange={setIsLGifImageOn}
          />
          {isIOS && (
            <LaboratorySwitch
              laboratoryKey="IS_TOUCH_VIBRATION"
              isOn={isTouchVibrationOn ?? false}
              onChange={setIsTouchVibrationOn}
            />
          )}
          <LaboratorySwitch
            laboratoryKey="IS_SELECT_GOODS_SCREEN_SHOT_SHARE"
            isOn={isScreenShotShareOn ?? false}
            onChange={setIsScreenShotShareOn}
          />
          {showHomeLivePreview && (
            <LaboratorySwitch
              laboratoryKey="IS_HOME_LIVE_PREVIEW"
              isOn={isHomeLivePreviewOn ?? false}
              onChange={setIsHomeLivePreviewOn}
            />
          )}
        </ScrollView>
      </StackScreen>
    </AnalyticsScreen>
  );
};
export default Laboratory;
